import { useState } from "react";
import "./portfolio.css";
import Projects from "./Projects";
import ProjectsCategories from "./ProjectsCategories";
import data from "./data";

const Portfolio = () => {
	const [projects, setProjects] =useState(data);

  const categories = data.map(item =>item.category);
	const uniqCategories = ["all", ...new Set(categories)];

	const filterProjectsHandler = (category)=>{
		if(category==="all"){
			setProjects(data);
			return;
		}
	const filterProjects = data.filter(project => project.category === category)
		setProjects(filterProjects);
	}

	return (
		<section id="portfolio" >
			<h2 data-aos="fade-up" className="title">Portfolio</h2>
			<p data-aos="fade-up">
			</p>
			<div className="container portfolio__container" data-aos="fade-up">
				<ProjectsCategories 
				categories={uniqCategories}
				onFilterProjects={filterProjectsHandler}/>
				<Projects projects={projects}/>
			</div>
		</section>
	)
} 

export default Portfolio